/* eslint-disable camelcase */
jQuery(document).ready(function ($) {
	const $root = $('.md-insight');
	if (!$root.length) {
		return;
	}

	const $content = $root.find('.md-insight__content');
	const $tocSidebar = $root.find('.md-insight__sidebar--toc');
	const mqDesktopDown = window.matchMedia('(max-width: 1200px)');
	const mqReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
	let tocOpenBusy = false;

	function getToc() {
		return $root.find('.md-insight-toc').first();
	}

	function getTocToggle() {
		return getToc().find('.md-insight-toc__toggle');
	}

	function getHeaderEl() {
		return document.getElementById('header') || document.querySelector('header.header');
	}

	function getHeaderHeight() {
		const header = getHeaderEl();
		return header ? Math.ceil(header.getBoundingClientRect().height) : 0;
	}

	function getHeaderOffset() {
		return getHeaderHeight() + 24;
	}

	function syncStickyTop() {
		if (!$tocSidebar.length) {
			return;
		}
		const top = Math.max(getHeaderHeight(), 1) + 'px';
		$tocSidebar.css('--insight-sticky-top', top);
		getToc().css('--insight-sticky-top', top);
	}

	/**
	 * Place sidebar CTA near 30% of main column height, but never overlap
	 * the featured article (keeps a small gap under it).
	 */
	function syncSideCtaOffset() {
		const $main = $root.find('.md-insight__main');
		const $cta = $root.find('[data-md-insight-side-cta]');
		const $author = $root.find('.md-insight__sidebar--author');

		if (!$main.length || !$cta.length || !$author.length) {
			return;
		}

		// Tablet/mobile: natural flow spacing from CSS.
		if (window.matchMedia('(max-width: 1200px)').matches) {
			$cta.css('--md-insight-side-cta-offset', '');
			return;
		}

		const mainHeight = $main.outerHeight() || 0;
		const targetFromAuthorTop = mainHeight * 0.3;
		const ctaIndex = $cta.index();
		let occupiedBeforeCta = 0;

		$author.children().each(function (index) {
			if (index >= ctaIndex) {
				return false;
			}
			occupiedBeforeCta += $(this).outerHeight(true) || 0;
		});

		const gap = 40; // ~2.5rem minimum clearance under Featured Article
		const offset = Math.max(gap, Math.round(targetFromAuthorTop - occupiedBeforeCta));
		$cta.css('--md-insight-side-cta-offset', offset + 'px');
	}

	/** Compact TOC UI is the visible toggle bar (tablet/mobile). */
	function isCompactToc() {
		const $toggle = getTocToggle();
		if (!$toggle.length) {
			return false;
		}
		// Prefer visibility over matchMedia — survives zoom / DevTools quirks.
		if ($toggle.is(':visible')) {
			return true;
		}
		return mqDesktopDown.matches;
	}

	/** True when the sticky TOC bar has reached its under-header position. */
	function isTocStuckUnderHeader() {
		if (!$tocSidebar.length) {
			return true;
		}
		syncStickyTop();
		const stickyTop = getHeaderHeight();
		return $tocSidebar[0].getBoundingClientRect().top <= stickyTop + 2;
	}

	function scrollTocUnderHeader() {
		return new Promise(function (resolve) {
			if (!$tocSidebar.length || isTocStuckUnderHeader()) {
				resolve();
				return;
			}

			const stickyTop = getHeaderHeight();
			const target = Math.max(0, Math.round($tocSidebar.offset().top - stickyTop));

			if (mqReduceMotion.matches) {
				window.scrollTo(0, target);
				window.requestAnimationFrame(function () {
					resolve();
				});
				return;
			}

			$('html, body')
				.stop(true)
				.animate({ scrollTop: target }, 320)
				.promise()
				.then(function () {
					resolve();
				});
		});
	}

	function setTocOpen(open) {
		const $toc = getToc();
		if (!$toc.length) {
			return;
		}

		const $toggle = $toc.find('.md-insight-toc__toggle');
		let $backdrop = $root.find('.md-insight-toc__backdrop').first();
		if (!$backdrop.length) {
			$backdrop = $('body > .md-insight-toc__backdrop').first();
		}

		const compactOpen = !!(open && isCompactToc());

		if (compactOpen) {
			syncStickyTop();
		}

		$toc.toggleClass('is-open', !!open);
		$tocSidebar.toggleClass('is-toc-open', compactOpen);
		$toggle.attr('aria-expanded', open ? 'true' : 'false');
		$('body').toggleClass('md-insight-toc-open', compactOpen);

		if ($backdrop.length) {
			if (compactOpen) {
				// Escape sticky/overflow stacking contexts.
				$backdrop.appendTo(document.body);
				$backdrop.removeAttr('hidden');
			} else {
				$backdrop.attr('hidden', 'hidden');
				// Keep backdrop next to TOC in the sidebar when closed.
				if ($tocSidebar.length) {
					$backdrop.appendTo($tocSidebar);
				}
			}
		}
	}

	function closeToc() {
		tocOpenBusy = false;
		setTocOpen(false);
	}

	function openTocCompact() {
		if (tocOpenBusy || getToc().hasClass('is-open')) {
			return;
		}
		tocOpenBusy = true;
		scrollTocUnderHeader().then(function () {
			syncStickyTop();
			setTocOpen(true);
			tocOpenBusy = false;
		});
	}

	function getHeadings() {
		return $content
			.find('h2')
			.not('.webinar-accordion h2, .title-webinar, .faq__title h2, h2[data-insight-toc-exclude], .faq__title-heading');
	}

	function getHeadingByLink($link) {
		const index = parseInt($link.data('heading-index'), 10);
		const $headings = getHeadings();

		if (!isNaN(index) && $headings.eq(index).length) {
			return $headings.eq(index);
		}

		const href = $link.attr('href');
		if (href && href.charAt(0) === '#') {
			const $byId = $(href);
			if ($byId.length) {
				return $byId;
			}
		}

		return $();
	}

	function scrollToHeading($heading) {
		if (!$heading.length) {
			return;
		}

		const top = $heading.offset().top - getHeaderOffset();
		$('html, body').stop(true).animate({ scrollTop: Math.max(0, top) }, 400);
	}

	function setActiveLink($heading) {
		const $tocLinks = getToc().find('.md-insight-toc__link');
		$tocLinks.removeClass('is-active');
		if (!$heading.length) {
			return;
		}

		const headingIndex = $heading.data('insight-heading');
		if (headingIndex) {
			$tocLinks.filter('[data-heading-index="' + (headingIndex - 1) + '"]').addClass('is-active');
			return;
		}

		const id = $heading.attr('id');
		if (id) {
			$tocLinks.filter('[href="#' + id + '"]').addClass('is-active');
		}
	}

	function onScroll() {
		const $headings = getHeadings();
		if (!$headings.length) {
			return;
		}

		const scrollPos = $(window).scrollTop() + getHeaderOffset() + 8;
		let $active = $();

		$headings.each(function () {
			if ($(this).offset().top <= scrollPos) {
				$active = $(this);
			}
		});

		setActiveLink($active);
	}

	// Delegation: works even if TOC markup is delayed / replaced.
	$(document).on('click', '.md-insight .md-insight-toc__toggle', function (event) {
		event.preventDefault();
		event.stopPropagation();
		const $toc = $(this).closest('.md-insight-toc');
		if ($toc.hasClass('is-open')) {
			closeToc();
			return;
		}
		if (isCompactToc()) {
			openTocCompact();
			return;
		}
		setTocOpen(true);
	});

	$(document).on('click', '.md-insight-toc__backdrop', function () {
		closeToc();
	});

	// Swipe up on the bottom handle closes the compact TOC sheet.
	let tocHandleTouchY = null;

	$(document).on('touchstart', '.md-insight-toc__handle', function (event) {
		if (!isCompactToc() || !getToc().hasClass('is-open')) {
			return;
		}
		const touch = event.originalEvent && event.originalEvent.touches
			? event.originalEvent.touches[0]
			: null;
		tocHandleTouchY = touch ? touch.clientY : null;
	});

	$(document).on('touchmove', '.md-insight-toc__handle', function (event) {
		if (tocHandleTouchY === null) {
			return;
		}
		const touch = event.originalEvent && event.originalEvent.touches
			? event.originalEvent.touches[0]
			: null;
		if (!touch) {
			return;
		}
		// Negative delta = finger moved up.
		if (touch.clientY - tocHandleTouchY <= -36) {
			tocHandleTouchY = null;
			closeToc();
		}
	});

	$(document).on('touchend touchcancel', '.md-insight-toc__handle', function () {
		tocHandleTouchY = null;
	});

	$(document).on('click', '.md-insight .md-insight-toc__link', function (event) {
		event.preventDefault();
		const $heading = getHeadingByLink($(this));
		if (isCompactToc()) {
			closeToc();
		}
		window.requestAnimationFrame(function () {
			scrollToHeading($heading);
		});
	});

	$(document).on('keydown', function (event) {
		if (event.key === 'Escape' && getToc().hasClass('is-open')) {
			closeToc();
		}
	});

	function onViewportChange() {
		syncStickyTop();
		syncSideCtaOffset();
		if (!isCompactToc()) {
			closeToc();
		}
		onScroll();
	}

	$(window).on('scroll resize', function () {
		syncStickyTop();
		onScroll();
	});

	$(window).on('resize', syncSideCtaOffset);
	$(window).on('load', function () {
		syncStickyTop();
		syncSideCtaOffset();
	});

	if (typeof mqDesktopDown.addEventListener === 'function') {
		mqDesktopDown.addEventListener('change', onViewportChange);
	} else if (typeof mqDesktopDown.addListener === 'function') {
		mqDesktopDown.addListener(onViewportChange);
	}

	syncStickyTop();
	syncSideCtaOffset();
	onScroll();

	// Recalc after images / embeds settle.
	if (typeof window.ResizeObserver === 'function') {
		const mainEl = $root.find('.md-insight__main').get(0);
		if (mainEl) {
			const ro = new window.ResizeObserver(function () {
				syncSideCtaOffset();
			});
			ro.observe(mainEl);
		}
	}
	$content.find('.slider-container').each(function () {
		const $container = $(this);
		const $previews = $container.find('.preview-image');
		const $slides = $container.find('.slide');
		let currentIndex = 0;

		function updateSlider() {
			$slides.each(function (index) {
				$(this).toggle(index === currentIndex);
			});
			$previews.removeClass('active').eq(currentIndex).addClass('active');
		}

		$previews.on('click', function () {
			currentIndex = $previews.index(this);
			updateSlider();
		});

		updateSlider();
	});
});
